module.exports = __webpack_public_path__ + "static/media/neighborhoodPride_48.15151137.png";